module.exports = __webpack_public_path__ + "static/media/297255.65c3eee0.png";